import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=edd0bcbc&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"
import style0 from "./Evaluation.vue?vue&type=style&index=0&id=edd0bcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd0bcbc",
  null
  
)

export default component.exports